export const getPriceFormatter = (currency: string) => {
    return new Intl.NumberFormat(document.documentElement.lang, {
      style: "currency",
      currency: currency,

    });
  }

export const formatPrice = (value: number, currency: string, maximumFractionDigits = 0) => {
    if (value == -1) return "";
    const formatter = new Intl.NumberFormat(document.documentElement.lang, {
        style: "currency",
        currency: currency,
        maximumFractionDigits: maximumFractionDigits
    });
    return formatter.format(value);
}


export const formatPriceEmptyIfUndefined = (value: number | undefined, currency: string | undefined,
    maximumFractionDigits = 0, minimumFractionDigits: number | undefined = undefined) => {
    if (value == -1 || value == undefined || currency == undefined) return "";
    const formatter = new Intl.NumberFormat(document.documentElement.lang, {
        style: "currency",
        currency: currency,
        maximumFractionDigits: maximumFractionDigits,
        minimumFractionDigits: minimumFractionDigits
    });
    return formatter.format(value);
}

export const formatPriceRange = (from: number, to: number, currency: string, maximumFractionDigits = 0) => {
    if (from == -1 || to == -1) return "";
    const formatter = new Intl.NumberFormat(document.documentElement.lang, {
        style: "currency",
        currency: currency,
        maximumFractionDigits: maximumFractionDigits
    });
    //@ts-ignore
    return formatter.formatRange(from, to);
}

export const formatPriceRangeEmptyIfUndefined = (from: number | undefined, to: number | undefined, currency: string | undefined, maximumFractionDigits = 0) => {
    if (from == -1 || to == -1 || from == undefined || to == undefined || currency == undefined) return "";
    const formatter = new Intl.NumberFormat(document.documentElement.lang, {
        style: "currency",
        currency: currency,
        maximumFractionDigits: maximumFractionDigits
    });
    //@ts-ignore
    return formatter.formatRange(from, to);
}


export const formatDate = (value: Date,
    dateStyle: "short" | "full" | "long" | "medium" | undefined = "medium",
    timeStyle: "short" | "full" | "long" | "medium" | undefined = undefined) => {
    const formatter = new Intl.DateTimeFormat(document.documentElement.lang, {
        dateStyle: dateStyle,
        timeStyle: timeStyle,
    });
    return formatter.format(value);
}

export const formatDateRange = (fromDate: Date | undefined, toDate: Date | undefined,
    dateStyle: "short" | "full" | "long" | "medium" | undefined = "medium",
    timeStyle: "short" | "full" | "long" | "medium" | undefined = undefined) => {

    if (fromDate == undefined || toDate == undefined) return "";

    const formatter = new Intl.DateTimeFormat(document.documentElement.lang, {
        dateStyle: dateStyle,
        timeStyle: timeStyle,
    });
    //@ts-ignore
    return formatter.formatRange(fromDate, toDate);
}

export const formatDateRangeOrYear = (fromDate: Date, toDate: Date,
    dateStyle: "short" | "full" | "long" | "medium" | undefined = "medium",
    timeStyle: "short" | "full" | "long" | "medium" | undefined = undefined) => {

    const year = getYearFromDateRange(fromDate, toDate);

    if (year != undefined) return year.toString();

    const formatter = new Intl.DateTimeFormat(document.documentElement.lang, {
        dateStyle: dateStyle,
        timeStyle: timeStyle,
    });
    //@ts-ignore
    return formatter.formatRange(fromDate, toDate);
}

const getYearFromDateRange = (fromDate: Date, toDate: Date) => {
    const expectedYear = fromDate.getFullYear();
    const expectedRange = {
        from: new Date(expectedYear, 0, 1),
        to: new Date(expectedYear + 1, 0, 1)
    };
    if (fromDate.getTime() == expectedRange.from.getTime() &&
            toDate.getTime() == expectedRange.to.getTime()) {
            return expectedYear;
        }
    return undefined;
}

export const getMonthName = (month: number, style: "short" | "long" | "numeric" | "2-digit" | "narrow" | undefined = "long") => {
    const formatter = new Intl.DateTimeFormat(document.documentElement.lang, {
        month: style
    });

    return formatter.format(new Date(2024, month))
}

export const getMonthNameWithYear = (firstYear: number, month: number, style: "short" | "long" | "numeric" | "2-digit" | "narrow" | undefined = "long") => {
    return getMonthName(month % 12) + " " + (firstYear + Math.floor(month/12))
}

export function capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}


export const formatNumber = (number: number | undefined, formatOptions?: Intl.NumberFormatOptions) => {
    if (number == undefined) return "";
    const formatter = new Intl.NumberFormat(document.documentElement.lang, formatOptions);
    return formatter.format(number);
}

// Logic for returning propertyId after it has been cleaned up
export const cleanUpPropertyId = (propertyId: string | number | undefined): string => {
  if (propertyId == null) return "";

  const raw = typeof propertyId === "number" ? propertyId.toString() : propertyId;

  // Find the first index of either "#" or "%23"
  const hashIndex = raw.indexOf("#");
  const encodedHashIndex = raw.indexOf("%23");

  // Get the earliest index of either symbol
  let cutoffIndex = -1;
  if (hashIndex >= 0 && encodedHashIndex >= 0) {
    cutoffIndex = Math.min(hashIndex, encodedHashIndex);
  } else {
    cutoffIndex = Math.max(hashIndex, encodedHashIndex);
  }

  console.log()

  return cutoffIndex >= 0 ? raw.substring(0, cutoffIndex) : raw;
};

